module.exports = __webpack_public_path__ + "static/media/payment-icon.884b5b84.svg";